export enum RadioSize {
  SMALL = 'small',
  LARGE = 'large',
}

export enum RadioOrientation {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}

export interface RadioOptionItem<T = string> {
  value: T;
  displayText: string;
  // Rendered in bold before `displayText`
  // should handle its own leading space/separator
  boldText?: string;
}

export type RadioTextColor = 'foreground' | 'white';
